<script>
    import { selectedLanguage } from "../etc/store.js"
</script>

{#if $selectedLanguage == "TW"}

<h4>我是誰？</h4>

<div id="me-top" >
<div id="me-top-text">

我是王而樵，出生成長於台北市，如今將近耳順之年。

我喜歡中華文化、喜歡文史，但是選擇了學習科技。大學一年級的時候，曾經每周日一大早，就要換 3
趟公車，從士林的家裡，到位於台北市健康路的一個教室，聽于紉藍老太太講易經，到了快要中午，再坐 3
趟公車回家吃中飯，就這樣從秋天到初夏，前後過了也有八個月吧。雖然聽得糊裡糊塗，但這算也是為我開了一扇學習易經的門。
之後，興趣又被帶到了不同的地方，東看看、西弄弄，大學畢業、當完了兵，在
1989 年到美國唸了研究所。之後，投入了高科技產業的洪流，也算是為今日人類生活的便利，盡了一點點的心力。

在 2019 年初夏，有個機會到李伯彥老師台北的教室聽了 3 講易經，參加了李老師的易經班，就又重新開始了易經的學習。
到今天為止，我對易經的理解、占卦的本事，連初學乍練都談不上。

</div>
<div  class="right" id="me-pic" >
<img src="https://lh3.googleusercontent.com/e2ijstEhriA3vhjM3SpkMHl3DQidS7QyzkgdCgieIDbpuc9I3jA3M0kzZkXblV0vOriz_RObAcu0ohVkJFnNb0OGsaHoUD4nojMxU547K8O32GiITrv2LLAt2hYb7rTwSw2P6m0Z-w=w960-h1438-no" width="80%" >
</div>
</div>
<h5>為什麼做【XiYi 習易網】？</h5>

孔子晚年學易，年過七十之後才覺得能夠從心所欲而不踰矩，並感嘆要是能早幾年學易就更好了，
說完沒多久就辭世。好可惜呀！我開始想要好好學易的年紀，要比孔子老得更多，從各種客觀指標來看，
我要把【易】學好的機率，是非常小的。這倒也無所謂，因為我現在是把學【易】，當作我晚年生活的一部份功課。

自古以來，學易高手的共同心得大概就是「演卦容易，斷卦難」，「占卦容易，解卦難」，
或是「善易者不卜」。可是，對我這種資質平庸的人而言，即使是這些感受也難以企及，只能遠遠地向他們敬禮，
也許有一天我也能夠體會那些高手的「感嘆」。現在，我至少能夠理解孔老夫子學易時為什麼會「韋編三絕」，
雖然，不太用功的我到現在連一本書都還沒翻破，不過，我的確體會到了的韋編三絕的原因：各卦相連、各爻相關、卦變爻進、卦中有卦、等等。
結果就是需要攤開一桌子的書、翻來翻去、勤做筆記也來不及、做不全。對一個用功學易多年的人來說，整理成堆的卦例，又會成為另外一個頭痛的事情！

孔老夫子這麼聰明努力的人，當初學習易經「韋編三絕」，把編竹簡的牛皮翻斷了多次，而我這個普通資質的老人想要學易，只好靠現代技術幫手。
市面上找不到合用的，就自己試著做一個。

這就是 【XiYi 習易網】的開始。自己用了一陣子，覺得還行，就把它弄得穩定一點、好看一點，變成一項雲端服務。目前我把【XiYi
習易網】定位成一個「原則要守、情懷要有、費用要收的小店」。

{:else }

<h4>我是谁？</h4>

<div id="me-top" >
<div id="me-top-text">

我是王而樵，出生成长于台北市，如今将近耳顺之年。

我喜欢中华文化、喜欢文史，但是选择了学习科技。大学一年级的时候，曾经每周日一大早，就要换 3
趟公车，从士林的家里，到位于台北市健康路的一个教室，听于纫蓝老太太讲易经，到了快要中午，再坐 3
趟公车回家吃中饭，就这样从秋天到初夏，前后过了也有八个月吧。虽然听得糊里糊涂，但这算也是为我开了一扇学习易经的门。
之后，兴趣又被带到了不同的地方，东看看、西弄弄，大学毕业、当完了兵，在
1989 年到美国念了研究所。之后，投入了高科技产业的洪流，也算是为今日人类生活的便利，尽了一点点的心力。

在 2019 年初夏，有个机会到李伯彦老师台北的教室听了 3 讲易经，参加了李老师的易经班，就又重新开始了易经的学习。
到今天为止，我对易经的理解、占卦的本事，连初学乍练都谈不上。

</div>
<div  class="right" id="me-pic" >
<img src="https://lh3.googleusercontent.com/e2ijstEhriA3vhjM3SpkMHl3DQidS7QyzkgdCgieIDbpuc9I3jA3M0kzZkXblV0vOriz_RObAcu0ohVkJFnNb0OGsaHoUD4nojMxU547K8O32GiITrv2LLAt2hYb7rTwSw2P6m0Z-w=w960-h1438-no" width="80%" >
</div>
</div>
<h5>为什么做【XiYi 习易网】？</h5>

孔子晚年学易，年过七十之后才觉得能够从心所欲而不逾矩，并感叹要是能早几年学易就更好了，
说完没多久就辞世。好可惜呀！我开始想要好好学易的年纪，要比孔子老得更多，从各种客观指标来看，
我要把【易】学好的机率，是非常小的。这倒也无所谓，因为我现在是把学【易】，当作我晚年生活的一部份功课。

自古以来，学易高手的共同心得大概就是「演卦容易，断卦难」，「占卦容易，解卦难」，
或是「善易者不卜」。可是，对我这种资质平庸的人而言，即使是这些感受也难以企及，只能远远地向他们敬礼，
也许有一天我也能够体会那些高手的「感叹」。现在，我至少能夠理解孔老夫子学易时为什么会「韦编三绝」，
虽然，不太用功的我到现在连一本书都还没翻破，不过，我的确体会到了的韦编三绝的原因：各卦相连、各爻相关、卦变爻进、卦中有卦、等等。
结果就是需要摊开一桌子的书、翻来翻去、勤做笔记也来不及、做不全。对一个用功学易多年的人来说，整理成堆的卦例，又会成为另外一个头痛的事情！

孔老夫子这么聪明努力的人，当初学习易经「韦编三绝」，把编竹简的牛皮翻断了多次，而我这个普通资质的老人想要学易，只好靠现代技术帮手。
市面上找不到合用的，就自己试著做一个。

这就是 【XiYi 习易网】的开始。自己用了一阵子，觉得还行，就把它弄得稳定一点、好看一点，变成一项云端服务。目前我把【XiYi
习易网】定位成一个「原则要守、情怀要有、费用要收的小店」。

{/if}

<style>
    p {
    font-size: 16px;
  }
    li {
    font-size: 16px;
  }
    ul li {
    margin-left: 40px;
    list-style-type: square !important;
  }
  #me-top{
    display: flex;
    flex-flow: wrap;
    /* grid-template-columns: 1fr 1fr; */
  }
  #me-top-text{
    flex: 60%;
     /* width: 100%; */
    /* min-width: 300px;
    max-width: 600px; */
  }
  #me-pic{
    min-width: 200px;
    max-width: 400px;
    margin-top: 20px;
    margin-left: 20px;
  }
</style>
